<template>
    <article class="col-12 col-sm-6 col-lg-4 col-xxl-3 mb-5">
        <router-link
            :to="{ name: 'Membre-fr', params: { slug: memberData.slug } }"
            class="card-index"
        >
            <div class="card-header">
                <AssetLoader
                    v-if="memberData.imageId !== 0"
                    :asset="{ asset: memberData.imageId }"
                    transform="?mode=crop&width=525&height=290"
                />
                <AssetLoader
                    v-else-if="globals.formationTabsTitleSections.formateursDefaultImage !== null"
                    :asset="{ asset: globals.formationTabsTitleSections.formateursDefaultImage.image.imageID }"
                    transform="?mode=crop&width=525&height=290"
                />
                <div class="overlay"></div>
            </div>


            <div class="card-body">
                <div class="subject-wrapper">
                    <h6 class="title" v-if="memberData.surname">{{ memberData.surname }}</h6>
                    <h6 class="title" v-else>{{ memberData.lName + ', ' + memberData.fName }}</h6>
                </div>

                <div class="subject-wrapper">
                    <p class="exerpt" v-html="formatMemberTitle(memberData.title)"></p>
                </div>
            </div>
            <div class="card-footer">
                <p class="link-arrow left-to-right bold text-red no-margin"></p>
            </div>
        </router-link>
    </article>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

import { formatMemberTitle } from '@/plugins/Helpers'

export default {
    name: 'MemberCard',
    components: {
        AssetLoader,
    },
    props: {
        memberData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        formatMemberTitle,
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
